var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0429 19.5C16.6756 19.5 20.6684 15.5098 22.4901 13.3503C23.1569 12.5599 23.1569 11.4401 22.4901 10.6497C20.6684 8.49021 16.6756 4.5 12.0429 4.5C7.41031 4.5 3.41746 8.49021 1.59577 10.6497C0.929015 11.4401 0.929015 12.5599 1.59577 13.3503C3.41746 15.5098 7.41031 19.5 12.0429 19.5ZM12.0429 16C14.2521 16 16.0429 14.2091 16.0429 12C16.0429 9.79086 14.2521 8 12.0429 8C9.83381 8 8.04294 9.79086 8.04294 12C8.04294 14.2091 9.83381 16 12.0429 16Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatching);
export default __webpack_public_path__ + "static/media/Watching.739dadacc1efc9d344a3cd318718a374.svg";
export { ForwardRef as ReactComponent };